<template>
  <div class="horizontal-nav">
    <router-link to="/home" class="nav-item">
      <i class="iconfont icon-shouye"></i>
      <span>首页</span>
    </router-link>
    <router-link to="/entry" class="nav-item">
      <i class="iconfont icon-wiki"></i>
      <span>WIKI</span>
    </router-link>
    <router-link to="/list" class="nav-item">
      <i class="iconfont icon-youxiku"></i>
      <span>社区</span>
    </router-link>
    <router-link to="/user" class="nav-item" v-if="loginUid>0">
      <i class="iconfont icon-wode"></i>
      <span>我的</span>
    </router-link>
    <div class="nav-item" @click="isLogin" v-else>
      <i class="iconfont icon-wode"></i>
      <span>我的</span>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'horizontalNav',
    mixins: [],
    props: {},
    model: {},
    components: {},
    data () {
      return {};
    },
    computed: {},
    methods: {},
    watch: {},
    created () {
    },
    mounted () {
    },
    updated () {
    },
    beforeDestroy () {
    },
    destroyed () {
    }
  };
</script>

<style scoped lang="less">
.horizontal-nav {
  position: fixed;
  left: 0;
  top: 0;
  width: 60px;
  height: 100%;
  background: #191F23;
  box-shadow: 2px 0px 4px 0px rgba(224, 224, 224, 0.5000);
  color: #B4B4B4;
  font-size: 11px;
  display: flex;
  flex-direction: column;
  z-index: @middle-z-index;

  .nav-item {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    color: inherit;

    &.router-link-active {
      color: @text-primary;
    }

    .iconfont {
      font-size: 24px;
      margin-bottom: 5px;
    }
  }
}
</style>
